import './App.css';
import {BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import {Layout} from "./Components/Layout";
import Wizard from "./Pages/Wizard";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Wizard />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
